import { DataGrid } from "@mui/x-data-grid";

/**
 * ScrollableDataGrid
 * Wraps MUI DataGrid providing an internal horizontal scroll container
 * that preserves outer page padding/margins. When total column width exceeds
 * available space, only this container scrolls horizontally.
 *
 * Heuristic min width calculation: width > minWidth > flex fallback.
 */
export function ScrollableDataGrid({
  columns = [],
  wrapperSx,
  dataGridSx,
  explicitMinWidth,
  ...dataGridProps
}) {
  return (
    <DataGrid
      disableRowSelectionExcludeModel
      {...dataGridProps}
      columns={columns}
      sx={{
        border: 0,
        marginTop: 2,
        ...dataGridSx,
        ...(dataGridProps.sx || {}),
      }}
    />
  );
}

export default ScrollableDataGrid;
